module.exports = __webpack_public_path__ + "static/media/upright.3166f2ff.svg";